import React from "react";
import { Link } from "react-router";
import './styles/NotFound.css'; // Importing the external CSS file

export default function NotFound404() {
  return (
    <div className="notfound-container">
      <div className="notfound-content">
        <h1 className="notfound-code">404</h1>
        <p className="notfound-message">Oops! Looks like you're lost. 🌍</p>
        <p className="notfound-submessage">No worries, we'll get you back on track!</p>
        <Link to="/" className="notfound-link">
          Go back home
        </Link>
      </div>
      <div className="notfound-illustration">     
      </div>
    </div>
  );
}